import { PageLoading } from "@ant-design/pro-layout";
import { useRequest } from "ahooks";
import { createContext, FC, ReactNode, useContext, useReducer } from "react";
import { Action, DataType, ReducerType, Refrences, Type } from "./types";
import auth from "services/shared/auth";

const defaultRefrence: Refrences = {
  loading: true,
};

const defaultData: DataType = {
  authorized: false,
  settings: {
    layout: "side",
    navTheme: "dark",
    colorWeak: false,
    title: "VMS",
    fixedHeader: true,
    fixSiderbar: true,
    contentWidth: "Fluid",
    listen_socket: false,
  },
  refrences: { ...defaultRefrence },
  notificationsCount: 0,
};

const reducer: ReducerType = (state, action) => {
  switch (action[0]) {
    case Action.SIGN_IN:
      return { ...state, auth: action[1], authorized: true };
    case Action.INCREASE_NOTI_COUNT:
      return { ...state, notificationsCount: state.notificationsCount + 1 };
    case Action.SIGN_OUT:
      auth.remToken();
      return { ...state, auth: undefined, authorized: false };
    default:
      return state;
  }
};

const UserContext = createContext<Type>([
  defaultData,
  () => {
    // do nothing.
  },
  {
    info: () => {},
  },
]);

export const StoreProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [redux, setRedux] = useReducer(reducer, defaultData);
  const _info = useRequest(auth.info, {
    onSuccess: (data) => setRedux([Action.SIGN_IN, data]),
  });

  return (
    <UserContext.Provider value={[redux, setRedux, { info: _info.refresh }]}>
      {_info.loading ? <PageLoading /> : children}
    </UserContext.Provider>
  );
};

export const useStore: () => Type = () => useContext<Type>(UserContext);
